<!--
 * @Author: WeijianXu weijian.xu@unidt.com
 * @Date: 2024-06-25 15:58:20
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-06-26 11:43:02
 * @FilePath: \intelligent-knowledge-qa-pcd:\app\reps\ai-qa\assistant_portal_web\src\components\frame\widgets\DialogPassword.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <DialogPasswordUpdate
    :visible="visible"
    :loading="formLoading"
    :theme="theme"
    @update:visible="updateVisible"
    @submit="submitForm"
  />
</template>
<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
// import { PasswordUpdateDialog } from 'ai-assistant-lib';

import DialogPasswordUpdate from './DialogPasswordUpdate.vue';
import { updatePassWord } from '@/data/ApiPersonnel';
import storeAccount from '@/config/storeAccount.js';

export default {
  components: {
    DialogPasswordUpdate,
    // PasswordUpdateDialog
  },
  props: {
    visible: {
      type: Boolean,
      default: () => false,
    },
    theme: {
      type: String,
      default: () => '',
    },
  },
  emits: ['update:visible'],
  setup(props, ctx) {
    const formLoading = ref(false);
    const account = storeAccount();
    const router = useRouter();

    //表单操作
    const handleClose = () => {
      updateVisible(false);
    };
    const submitForm = (formData) => {
      updatePassWord({
        // passWord: formData.passWord,
        // newPassWord: formData.newPassWord,
        // phid: account.accountId,
        ...formData,
      })
        .then((res) => {
          if (res) {
            ElMessage.success('修改密码成功');
            handleClose();
            setTimeout(() => {
              if (sessionStorage.getItem('authentication')) {
                router.push({ name: 'authentication' });
              } else if (sessionStorage.getItem('controlConsole')) {
                router.push({ name: 'login' });
              } else {
                account.Logout().then(() => {
                  router.push({ name: 'homeLogin' });
                });
              }
            }, 1000);
          }
        })
        .finally(() => {
          formLoading.value = false;
        });
    };

    const updateVisible = (val) => {
      ctx.emit('update:visible', val);
    };
    return {
      // form,
      // formRules,
      // formData,
      formLoading,
      // handleClose,
      submitForm,
      updateVisible,
      // validatePass,
    };
  },
};
</script>
<style lang="scss"></style>
